var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81318 0 0 3.81318 0 8.5C0 13.1868 3.81318 17 8.5 17C13.1868 17 17 13.1868 17 8.5C17 3.81318 13.1868 0 8.5 0ZM8.5 16.1053C4.30656 16.1053 0.894737 12.6934 0.894737 8.5C0.894737 4.30656 4.30656 0.894737 8.5 0.894737C12.6934 0.894737 16.1053 4.30656 16.1053 8.5C16.1053 12.6934 12.6934 16.1053 8.5 16.1053Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94521 8.31547V3.43052C8.94521 3.18337 8.745 2.98315 8.49784 2.98315C8.25069 2.98315 8.05048 3.18337 8.05048 3.43052V8.50048C8.05048 8.61919 8.09754 8.73291 8.18154 8.81679L10.8658 11.501C10.953 11.5884 11.0676 11.6321 11.1821 11.6321C11.2965 11.6321 11.4111 11.5884 11.4984 11.501C11.6731 11.3262 11.6731 11.0431 11.4984 10.8684L8.94521 8.31547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3a895ca1f0832741f181cdd84e63d491.svg";
export { ForwardRef as ReactComponent };